import OrderRecord from 'records/order';
import { resourceReducer } from 'utils/reducerGenerator';

export const { reducer, types } = resourceReducer(
    { namespace: 'ORDER', transformer: OrderRecord }
);

export default reducer;
